import { FunctionComponent, useMemo } from 'react';
import { useSettingsSlice } from '@pp/core';

import styles from './GameBackground.module.css';
export const GameBackgroundConnected: FunctionComponent = () => {
  const isClassicMode = useSettingsSlice.getIsInClassicView();

  const gameBackground = useMemo(() => {
    if (isClassicMode) return styles.gameBackgroundClassic;
    return styles.gameBackground;
  }, [isClassicMode]);

  return <div className={`${gameBackground}`} />;
};
